import React from "react";
import { makeStyles, Box } from "@material-ui/core";
import CreditReloadLogPanel from "../creditReloadLogPanel";
import CreditAlertPanel from "../creditAlertPanel";
import CreditBalanceOverviewPanel from "../creditBalanceOverviewPanel";
import CreditBalanceDetailPanel from "../creditBalanceDetailPanel";
import CampaignTngDisbursementPanel from "../campaignTngDisbursementPanel";

const useStyle = makeStyles((theme) => ({
  root: {
    display: "grid",
    gridTemplateColumns: "1fr 2fr",
    gap: 16,
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  container: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 3, 2, 3),
    borderRadius: "8px",
  },
}));

export default function TngDisbursementSettingPanelComponent() {
  const classes = useStyle();

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <CreditBalanceOverviewPanel />
        <Box mt={4}>
          <CreditReloadLogPanel />
        </Box>
        <Box mt={4}>
          <CreditAlertPanel />
        </Box>
      </Box>
      <Box overflow="hidden">
        <Box className={classes.container}>
          <CreditBalanceDetailPanel />
        </Box>
        <Box className={classes.container} mt={2}>
          <CampaignTngDisbursementPanel />
        </Box>
      </Box>
    </Box>
  );
}
